import {
  FiHome,
  FiBarChart2,
  FiUsers,
  FiLayers,
  FiShoppingCart,
  FiPieChart,
  FiTable,
  FiEdit,
  FiGrid,
  FiCalendar,
  FiChevronRight,
  FiSettings,
  FiUser,
  FiGift,
  FiUserCheck,
  FiLogOut,
  FiChevronDown,
} from "react-icons/fi";
import { NavLink } from "react-router-dom";
import { useState } from "react";
import { TbMoneybag, TbTransactionRupee } from "react-icons/tb";
import { FiBox } from "react-icons/fi";
import { useAuth } from "../../context/AuthContext";
import { MdOutlineStackedBarChart } from "react-icons/md";


const menu = [
  { label: "Dashboard", icon: FiBox, to: "/" },
  { label: "Analytics", icon: MdOutlineStackedBarChart, to: "/analytics" },
  { label: "Members", icon: FiUsers, to: "/users" },
  { label: "Bonus & Panelty", icon: FiUsers, to: "/bonus-and-panelty" },
  { label: "Bonus & Panelty History", icon: FiUsers, to: "/bonus-and-panelty-history" },
  { label: "Collaborators", icon: FiUsers, to: "/collaborators" },
  { label: "Recharge List", icon: TbMoneybag, to: "/recharge-list" },
  { label: "Withdrawal List", icon: FiShoppingCart, to: "/withdrawal-list" },
  { label: "Gift Codes", icon: FiGift, to: "/gift-codes" },
  {
    label: "Support",
    icon: FiUsers,
    children: [
      { label: "Pending Issues", icon: FiUsers, to: "/pending-issues" },
      { label: "Resolved Issues", icon: FiUsers, to: "/resolved-issues" },
    ],
  },
  { label: "API Management", icon: FiLayers, to: "/api-management" },
  { label: "Wingo Management", icon: FiLayers, to: "/wingo-management" },

  {
    label: "Settings",
    icon: FiSettings,
    children: [
      {
        label: "Deposit Levels Commission",
        icon: FiUsers,
        to: "/settings/deposit/levels",
      },
      {
        label: "Bet Levels Commission",
        icon: FiUsers,
        to: "/settings/bet/levels",
      },
      // { label: "User Level", icon: FiGrid, to: "/settings/level" },
      { label: "Deposit Bonus", icon: FiGrid, to: "/settings/deposit/bonus" },
      { label: "General Settings", to: "/settings/general" },
      { label: "Payment Methods", to: "/settings/payments" },
    ],
  },
  { label: "Admin", icon: FiUserCheck, to: "/admin" },
];

const Sidebar = ({ isOpen, onClose, isCollapsed }) => {
  const [openGroups, setOpenGroups] = useState({});
  const { user, logout } = useAuth();

  const toggleGroup = (label) =>
    setOpenGroups((prev) => ({ ...prev, [label]: !prev[label] }));

  return (
    <>
      {/* Mobile overlay */}
      {isOpen && (
        <div
          className="fixed inset-0 bg-black/50 backdrop-blur-sm z-20 md:hidden transition-opacity duration-200"
          onClick={onClose}
        />
      )}

      <aside
        className={`
          fixed z-30 inset-y-0 left-0 w-72 
          bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900
          border-r border-slate-700/50
          shadow-2xl
          transform transition-transform duration-300 ease-in-out
          ${isOpen ? "translate-x-0" : "-translate-x-full"}
          md:static md:translate-x-0
          flex flex-col
        `}
      >
        {/* Logo Section */}
        <div className="h-20 flex items-center px-6 border-b border-slate-700/50">
          <div className="flex items-center gap-3">
            <div className="relative">
              <div className="w-10 h-10 rounded-xl bg-gradient-to-br from-yellow-400 to-orange-500 flex items-center justify-center shadow-lg">
                <span className="text-white font-bold text-lg">H</span>
              </div>
              <div className="absolute -top-1 -right-1 w-3 h-3 bg-green-400 rounded-full border-2 border-slate-900 animate-pulse"></div>
            </div>
            <div>
              <h1 className="text-white font-bold text-lg">
                habibi<span className="text-yellow-400">360</span>
              </h1>
              <p className="text-slate-400 text-xs">Admin Portal</p>
            </div>
          </div>
        </div>

        {/* Menu Navigation */}
        <nav className="flex-1 overflow-y-auto px-4 py-6 space-y-2 custom-scrollbar">
          {menu.map((item) => {
            const Icon = item.icon;
            const hasChildren = !!item.children?.length;
            const isOpenGroup = openGroups[item.label];

            if (!hasChildren) {
              return (
                <NavLink
                  key={item.label}
                  to={item.to}
                  className={({ isActive }) =>
                    `group flex items-center gap-3 px-4 py-3 rounded-xl transition-all duration-200 ${isActive
                      ? "bg-gradient-to-r from-yellow-600 to-yellow-600 text-white shadow-lg shadow-yellow-500/30"
                      : "text-slate-300 hover:bg-slate-800/50 hover:text-white"
                    }`
                  }
                  onClick={onClose}
                >
                  <Icon className="text-lg flex-shrink-0" />
                  <span className="font-medium text-sm">{item.label}</span>
                  {!hasChildren && (
                    <div className="ml-auto opacity-0 group-hover:opacity-100 transition-opacity">
                      <FiChevronRight className="text-xs" />
                    </div>
                  )}
                </NavLink>
              );
            }

            return (
              <div key={item.label} className="space-y-1">
                <button
                  onClick={() => toggleGroup(item.label)}
                  className={`group w-full flex items-center gap-3 px-4 py-3 rounded-xl transition-all duration-200 ${isOpenGroup
                    ? "bg-slate-800/70 text-white"
                    : "text-slate-300 hover:bg-slate-800/50 hover:text-white"
                    }`}
                >
                  <Icon className="text-lg flex-shrink-0" />
                  <span className="font-medium text-sm flex-1 text-left">
                    {item.label}
                  </span>
                  <FiChevronDown
                    className={`text-sm transition-transform duration-200 ${isOpenGroup ? "rotate-180" : ""
                      }`}
                  />
                </button>

                {isOpenGroup && (
                  <div className="ml-4 pl-4 border-l-2 border-slate-700/50 space-y-1 mt-1">
                    {item.children.map((child) => {
                      const ChildIcon = child.icon;
                      return (
                        <NavLink
                          key={child.label}
                          to={child.to}
                          className={({ isActive }) =>
                            `group flex items-center gap-3 px-3 py-2.5 rounded-lg transition-all duration-200 ${isActive
                              ? "bg-yellow-600/20 text-yellow-400 border-l-2 border-yellow-400"
                              : "text-slate-400 hover:bg-slate-800/30 hover:text-slate-200"
                            }`
                          }
                          onClick={onClose}
                        >
                          {ChildIcon && <ChildIcon className="text-sm" />}
                          <span className="text-xs font-medium">
                            {child.label}
                          </span>
                        </NavLink>
                      );
                    })}
                  </div>
                )}
              </div>
            );
          })}
        </nav>

        {/* User Profile Footer */}
        <div className="border-t border-slate-700/50">
          <div className="bg-slate-800/50 rounded-xl p-4 backdrop-blur-sm">
            <div className="flex items-center gap-3 mb-3">
              <div className="relative">
                <img
                  className="w-12 h-12 rounded-xl object-cover border-2 border-slate-700"
                  src="https://thumbs.dreamstime.com/b/user-sign-icon-person-symbol-human-avatar-rich-man-84519083.jpg"
                  alt="User avatar"
                />
                <div className="absolute -bottom-1 -right-1 w-4 h-4 bg-green-400 rounded-full border-2 border-slate-900"></div>
              </div>
              <div className="flex-1 min-w-0">
                <p className="font-semibold text-sm text-white truncate">
                  {user?.name || "Admin User"}
                </p>
                <p className="text-xs text-slate-400 truncate">
                  {user?.email || "admin@kaudaa.com"}
                </p>
              </div>
            </div>

            <div className="flex gap-2">

              <button
                onClick={() => {
                  logout();
                  onClose();
                }}
                className="flex-1 flex items-center justify-center gap-2 px-3 py-2 rounded-lg bg-red-600/20 hover:bg-red-600 text-red-400 hover:text-white transition-all duration-200 text-xs font-medium"
              >
                <FiLogOut className="text-sm" />
                Logout
              </button>
            </div>
          </div>
        </div>
      </aside>

      <style jsx>{`
        .custom-scrollbar::-webkit-scrollbar {
          width: 6px;
        }
        .custom-scrollbar::-webkit-scrollbar-track {
          background: rgba(51, 65, 85, 0.3);
          border-radius: 10px;
        }
        .custom-scrollbar::-webkit-scrollbar-thumb {
          background: rgba(99, 102, 241, 0.5);
          border-radius: 10px;
        }
        .custom-scrollbar::-webkit-scrollbar-thumb:hover {
          background: rgba(99, 102, 241, 0.7);
        }
      `}</style>
    </>
  );
};

export default Sidebar;